import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, LinearProgress } from '@mui/material';
import Swal from 'sweetalert2';
// CONTEXT
import usePlanDetailsContext from './context/usePlanDetailsContext';
// COMPONENTS
import PlanHeader from './components/PlanHeader';
import ProductCatalog from './components/ProductCatalog';
import PlanItemsGrid from './components/PlanItemsGrid';
import NotFoundTemplate from '../../components/AppLayout/NotFoundTemplate';
// API
import { postUpdatePlan } from '../../api/productSamplingWorkflowApi';
import { toast } from 'react-toastify';

export default function ProductManagerView() {
  const navigate = useNavigate();
  const { auth, plan, type, loading, planNotFound, categories } = useContext(usePlanDetailsContext);
  const [form, setForm] = useState({});

  const handleSubmit = async () => {
    try {
      toast.loading('processing request please wait...');

      if (!form.products.length) {
        throw new Error('Please select products');
      }

      const invalidProducts = form.products.filter((row) => Number(row.requested_qty) === 0);

      if (invalidProducts.length) {
        Swal.fire({
          icon: 'warning',
          title: 'Invalid Requested Quantity',
          html: invalidProducts.map((row) => `<div>${row.name}</div>`).join(''),
        });
        toast.dismiss();
        return;
      }

      const request = {
        id: form?.plan_id,
        title: form.title,
        category_id: form.category_id,
        sub_category_id: form.sub_category_id,
        products: form.products.map((row) => ({
          product_id: row.id,
          requested_qty: row.requested_qty,
        })),
      };

      const response = await postUpdatePlan(request);
      const { code } = response.data;

      if (code === '00003') {
        toast.dismiss();
        toast.success('Plan has been successfully submitted for confirmation');
        navigate('/maintenance/product-sampling-overview', { replace: true });
      }
    } catch (error) {
      toast.dismiss();
      toast.warning(error.message);
    }
  };

  useEffect(() => {
    setForm(plan);
  }, [plan]);

  if (loading) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  if (planNotFound) {
    return <NotFoundTemplate active={false} />;
  }

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: '#f5f7fa',
        minHeight: '100vh',
      }}
    >
      {form && (
        <PlanHeader
          auth={auth}
          type={type}
          form={form}
          setForm={setForm}
          handleSubmit={handleSubmit}
          categories={categories}
        />
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <ProductCatalog form={form} setForm={setForm} />
        </Grid>

        <Grid item xs={12} md={8}>
          <PlanItemsGrid type={type} form={form} setForm={setForm} />
        </Grid>
      </Grid>
    </Box>
  );
}
